<template>
  <div class="export" v-loading="loading">
    <div class="export__header"><span class="title">SENDOUTS REPORT</span></div>
    <div class="export__body">
      <div class="sub-header">
        <ul class="date-type-checkbox">
          <li class="checkbox-header">CHOOSE DATE TYPE</li>

          <li class="ml-20 radio-block">
            <label>
              <input
                type="checkbox"
                class="input-checkbox"
                value="collection_date"
                v-model="date_check"
                @change="uniqueCheck"
              />
              <h3>COLLECTION</h3>
            </label>
            <label>
              <input
                type="checkbox"
                value="received_date"
                class="input-checkbox"
                v-model="date_check"
                @change="uniqueCheck"
              />
              <h3>RECEIVED</h3>
            </label>
          </li>
        </ul>
        <el-button class="download-btn" @click="downloadCases">
          Download
        </el-button>
      </div>
      <div class="inputs">
        <el-row :gutter="20">
          <el-form>
            <el-col :xl="5" :lg="5" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"> From Date</label>

                  <el-date-picker
                    v-model="from_date"
                    type="date"
                    format="MM-DD-YYYY"
                    :disabled-date="disabledDate"
                    placeholder="Select From Date"
                    :editable="false"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="5" :lg="5" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"> To Date </label>
                  <el-date-picker
                    v-model="to_date"
                    type="date"
                    format="MM-DD-YYYY"
                    :disabled-date="disabledDate"
                    placeholder="Select To Date"
                    :editable="false"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="5" :lg="5" :md="3" :sm="6" :xs="6">
              <div
                class="case-creation__input"
                v-if="
                  getAuthenticatedUser &&
                  getAuthenticatedUser.user_type == 'LAB_TECHNOLOGIST' &&
                  getAuthenticatedUser.allowed_case_types
                "
              >
                <el-form-item>
                  <label for="text">Case Type </label>
                  <el-select
                    placeholder="Select Case Type"
                    v-model="case_types"
                    :filterable="true"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in getUserBasedCaseTypes(caseTypes)"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="case-creation__input" v-else>
                <el-form-item>
                  <label for="text">Case Type </label>
                  <el-select
                    placeholder="Select Case Type"
                    v-model="case_types"
                    :filterable="true"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in getLabBasedCaseTypes(caseTypes)"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="5" :lg="5" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Ordering Facility </label>
                  <el-select
                    placeholder="Select Ordering Facility"
                    v-model="hospital"
                    @change="fetchAllPhysicians"
                    filterable
                    remote
                    :remote-method="remoteMethodFacility"
                    :loading="hospitalLoading"
                  >
                    <el-option
                      v-for="hospital in hospitalsData.data"
                      :key="hospital"
                      :label="hospital.name"
                      :value="hospital._id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="5" :lg="5" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Ordering Physician </label>
                  <el-select
                    v-model="ordering_physician"
                    placeholder="Select Ordering Physician"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="physician in physiciansData.data"
                      :key="physician"
                      :label="physician.name"
                      :value="physician._id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>
    <div class="export__footer">
      <el-collapse v-model="sendOutReportCollapse">
        <el-row :gutter="15">
          <el-col :span="24">
            <div class="collapse-header">
              <el-collapse-item name="1">
                <div class="date-includes">
                  <div class="clear-btn">
                    <el-button
                      class="btn button-with-icon"
                      @click="handleClear"
                      :disabled="!this.activeFieldList.length"
                      >CLEAR ALL</el-button
                    >
                    <el-button
                      class="btn button-with-icon"
                      @click="handleCheckAllChange"
                      >SELECT ALL</el-button
                    >
                  </div>
                  <el-checkbox-group v-model="activeFieldList">
                    <ul class="check-list">
                      <li
                        v-for="(item, index) in exportSendOutsExcelFields"
                        :key="index"
                        class="search-checkbox"
                      >
                        <el-checkbox :label="item.value">
                          {{ item.label }}
                        </el-checkbox>
                      </li>
                    </ul>
                  </el-checkbox-group>
                </div>
              </el-collapse-item>
            </div>
          </el-col>
        </el-row>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import exportExcelHelper from "@/mixins/exportExcelHelper";
import exportSendoutsHelper from "@/mixins/sendoutDataHelper";
import caseConstants from "@/config/constants/caseConstants";
import caseDataHelper from "@/mixins/caseDataHelper";
export default {
  data() {
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      sendOutReportCollapse: "1",
      checkAll: true,
      date_type: "collection_date",
      from_date: "",
      to_date: "",
      hospital: "",
      ordering_physician: "",
      hospital_branch: "",
      hospitalBranches: [],
      activeFieldList: [],
      fieldList: [],
      caseTypes: caseConstants.CASE_TYPES_DATA,
      case_types: [],
      loading: false,
      hospitalLoading: false,
      date_check: [],
      hospitalsData: {},
      physiciansData: {},
    };
  },
  mixins: [exportExcelHelper, caseDataHelper, exportSendoutsHelper],
  computed: {
    mappedSelectedOptions() {
      return this.activeFieldList.map((option) => {
        return this.exportSendOutsExcelFields.find(
          (opt) => opt.value === option
        );
      });
    },
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("sendOuts", ["getSendoutsDownloadStatus"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
  },
  created() {
    this.activeFieldList = [
      ...this.defaultExportSendOutsExcelFields.map((opt) => opt.value),
    ];
  },
  mounted() {
    // this.checkDefaultExport();
    this.fetchAllHospitals();
  },
  methods: {
    handleClear() {
      this.activeFieldList = [];
    },
    uniqueCheck(e) {
      this.date_check = [];
      if (e.target.checked) {
        this.date_check.push(e.target.value);
      }
      this.date_type = this.date_check.toString();
    },
    async remoteMethodFacility(query) {
      await this.fetchAllHospitals(query);
    },
    async fetchAllHospitals(searchString) {
      this.hospitalLoading = true;
      let params = {
        limit: 25,
        status: "ACTIVE",
      };
      if (searchString) {
        params.search_string = searchString;
      }
      await this.$store.dispatch("hospitals/fetchAllHospitals", params);
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalLoading = false;
    },
    async fetchAllPhysicians() {
      let params = {};
      if (this.hospital != "") {
        params.hospital = this.hospital;
      } else {
        params.get_all = true;
      }
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
    },
    checkDefaultExport() {
      this.onExportReports();
    },
    onExportReports() {
      this.loadFieldsList();
    },
    loadFieldsList() {
      this.exportSendOutsExcelFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
    isCheckAll() {
      if (
        this.activeFieldList &&
        this.exportSendOutsExcelFields &&
        this.activeFieldList.length &&
        this.exportSendOutsExcelFields.length &&
        this.activeFieldList.length == this.exportSendOutsExcelFields.length
      ) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    handleCheckAllChange() {
      this.exportSendOutsExcelFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
    async downloadCases() {
      if (this.activeFieldList.length) {
        this.loading = true;
        let params = {
          include: this.activeFieldList,
        };
        params.date_type = this.date_type;
        if (this.from_date != "") {
          params.from_date = this.from_date;
        }

        if (this.to_date != "") {
          params.to_date = this.to_date;
        }
        if (this.case_types != []) {
          params.case_types = this.case_types;
        }
        if (this.hospital != "") {
          params.hospital = this.hospital;
        }
        if (this.ordering_physician != "") {
          params.ordering_physician = this.ordering_physician;
        }
        await this.$store.dispatch("sendOuts/downloadSendOutData", params);
        this.loading = false;
        if (this.getSendoutsDownloadStatus) {
          this.resetFilters();
        } else {
          this.$message({
            message: "Error in downloading Sendouts",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
    resetFilters() {
      this.from_date = "";
      this.to_date = "";
      this.case_types = [];
      this.hospital = "";
      this.ordering_physician = "";
    },
    handleSelectionChange(rows) {
      if (rows) {
        this.selectedSendOutIds = [];
        for (let sendOutData of rows) {
          this.selectedSendOutIds.push(sendOutData._id);
        }
      } else {
        this.selectedSendOutIds = [];
      }
    },
  },
};
</script>

<style></style>
